/*eslint-disable*/
import Cookies from 'js-cookie'
import * as cookies from '../../config/cookies'

export default {
    computed: {
        canShowConversations () {
            return this.user && this.user.type === 'student'
                && (Cookies.get(cookies.ADMIN_TOKEN) || Cookies.get(cookies.TEACHER_TOKEN))
        }
    }
}
